
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/success-stories/[id]",
      function () {
        return require("private-next-pages/success-stories/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/success-stories/[id]"])
      });
    }
  